import BakedBreadsDB, { BakedBreadEntity } from 'src/firebase/db/BakedBreads';

export const getBakedBreads = (shopId: string) => BakedBreadsDB.getBakedBreads(shopId);
export const getReservationBakedBreads = (shopId: string) =>
  BakedBreadsDB.getReservationBakedBreads(shopId);
export const createBakedBread = (query: BakedBreadEntity & { is_draft?: boolean }) => BakedBreadsDB.create(query);
export const updateBakedBread = (query: BakedBreadEntity) => BakedBreadsDB.update(query);
export const updateBakedBreadOrders = (query: { id: string; order: number }[]) =>
  BakedBreadsDB.updateBakedBreadOrders(query);

export const getShopBakedBreads = (shopId: string) => BakedBreadsDB.getShopBakedBreads(shopId);
